var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0667 17.5H6.73332C5.81248 17.5 5.06665 16.7542 5.06665 15.8333V9.16667C5.06665 8.24583 5.81248 7.5 6.73332 7.5H15.0667C15.9875 7.5 16.7333 8.24583 16.7333 9.16667V15.8333C16.7333 16.7542 15.9875 17.5 15.0667 17.5Z",
    fill: "#8A90A2",
    stroke: "#8A90A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9001 14.2416V12.0833",
    stroke: "#0F1923",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3418 11.0164C11.5859 11.2605 11.5859 11.6562 11.3418 11.9003C11.0978 12.1444 10.702 12.1444 10.458 11.9003C10.2139 11.6562 10.2139 11.2605 10.458 11.0164C10.702 10.7724 11.0978 10.7724 11.3418 11.0164",
    stroke: "#0F1923",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56665 7.5V5.83333V5.83333C7.56665 3.9925 9.05915 2.5 10.9 2.5V2.5C12.7408 2.5 14.2333 3.9925 14.2333 5.83333V5.83333V7.5",
    stroke: "#8A90A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.cf1d64a280f1084872ef6e72003b821b.svg";
export { ForwardRef as ReactComponent };